<mat-toolbar color="primary" class="aip-header-toolbar">
  <div [ngClass]="{icon: opened, iconcollapsed:!opened}">
    <div class="displayENV">{{envLabel}}</div>
  </div>

    <div class="header">
      <button mat-icon-button (click)="toggleMenu()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <span class="cfont-h1">{{envTitle}} Estate Maps</span>

    <span class="spacer"></span>

    <!--
    <div class="aip-topbaricon">
        <button mat-icon-button>
            <mat-icon>search</mat-icon>
        </button>
    </div>
    -->
    <!-- This is to get the full theme menu
    <div class="aip-topbaricon">
    <app-thememenu matTooltip="Select the theme"
      [options]="themes"
      (themeChange)="themeChangeHandler($event)">
    </app-thememenu>
    </div>
    -->

    <div class="global-search-container">
      <ng-select class="aip-board-search mat-elevation-z2 aip-theme-bg" [ngClass]="disableSearchDropdown() ? 'disable-select-dropdown' : ''"
        [items]="searchData"
        [groupBy]="needGroup ? groupByFn : ''"
        [searchFn]="searchFn"
        [loading]="isLoading"
        (change)="selectAccount($event)"
        (search)="handleSearch($event)"
        (blur)="handleBlur()"
        (clear)="handleBlur()"
        placeholder="SEARCH"
        [clearable]="true"
        bindValue="itemId"
        bindLabel="name"
        labelForId="globalSearchInput"
        [(ngModel)]="searchValue"
      >
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
          <span [matTooltip]="item.name" [matTooltipClass]="item.clientclass === 'FAQ' ? '' : 'capitalize-tooltip'" [class]="{ 'capitalize-option': item.clientclass !== 'FAQ' }">{{ item.name }}</span>
        </ng-template>
        <ng-template ng-optgroup-tmp let-item="item">
          <span style="vertical-align: middle; font-weight: bold; text-transform: uppercase;">{{ item.name }}</span>
        </ng-template>
      </ng-select>
    </div>
    <span class="spacer"></span>
    <div *ngIf="selectedMenuItem === 'landscape' && navService.landscapePageConfig.sAccount" class="aip-topbaricon" style="width: 130px;">
      <div class="toggle-layout-label">{{ navService.landscapePageConfig.useNewLayout ? 'Back To Classic' : 'Try New Style' }}</div>
      <button mat-icon-button (click)="toggleLayout()">
        <mat-icon style="width: 35px; height: 35px; line-height: 35px; font-size: 35px;">{{ navService.landscapePageConfig.useNewLayout ? 'toggle_on' : 'toggle_off' }}</mat-icon>
      </button>
    </div>
    <div class="aip-topbaricon">
      <button mat-icon-button matTooltip="Send feedback" (click)="showFeedBackDialog()">
        <mat-icon>chat</mat-icon>
      </button>
    </div>

    <div class="aip-topbaricon">
      <ng-container *ngIf="this.themeMode=='light'">
        <button mat-icon-button matTooltip="Switch to Dark Mode" (click)="changeThemeMode('dark')">
          <mat-icon>nights_stay</mat-icon>
        </button>
      </ng-container>
      <ng-container *ngIf="this.themeMode=='dark'">
        <button mat-icon-button matTooltip="Switch to Light Mode" (click)="changeThemeMode('light')">
          <mat-icon>wb_sunny</mat-icon>
        </button>
      </ng-container>
    </div>

    <div *ngIf="true" class="aip-topbaricon">
      <button matTooltip="" mat-icon-button (click)="this.showHelpDialog()">
        <fa-icon icon="info"></fa-icon>
      </button>
    </div>

    <div style="padding-left:10px"></div>

    <div class="aip-topbaricon">
      <app-user [user]="user"></app-user>
    </div>

</mat-toolbar>

<mat-sidenav-container class="container">
  <mat-sidenav #sidenav mode="side" [(opened)]="opened" (opened)="open()" (closed)="close()">

    <mat-nav-list>


      <div class="menu-item" *ngFor="let item of menuItems">
        <a [matTooltip]="item.label + (item['redirect-url'] && item['redirect-url'].trim()!=''?' : This is an external module and will open in a new tab':'')" mat-list-item class="{{ (selectedMenuItem==item.name ? 'selectedmenu' : '') }}" (click)="go(item.name)">

          <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
          <fa-icon *ngIf="item['fa-icon']" style="width:24px" icon="{{item['fa-icon']}}"></fa-icon>

          <span *ngIf="sidenav.opened" class="sidenav-item cfont-h2">{{ item.label }}</span>
        </a>
      </div>

      <div class="menu-bottom">
        <div class="menu-item">
          <!--
          <a [matTooltip]="'Change Log'" mat-list-item class="help-item" (click)="go('changelog')">
            <fa-icon style="width:24px" icon="clipboard-list"></fa-icon>
            <span *ngIf="sidenav.opened" class="sidenav-item cfont-h2">Change Log</span>
          </a>
          -->
        </div>
        <div *ngIf="helpLink!=''" class="menu-item">
          <a [matTooltip]="'Help'" mat-list-item class="help-item" (click)="showHelp()">
            <fa-icon style="width:24px" icon="question-circle"></fa-icon>
            <span *ngIf="sidenav.opened" class="sidenav-item cfont-h2">Help</span>
          </a>
        </div>
      </div>

    </mat-nav-list>

    <ng-container *ngIf="navService.landscapePageConfig.showLegend">
      <ng-container *ngIf="showLegendInOverlay; else sidebarLegendTemplate">
        <ng-container *ngIf="renderOverlay">
          <div [class]="sidenav.opened ? 'legend-overlay-button' : 'collapsed-legend-overlay-button'" (mouseover)="openOverlay()" (mouseout)="hideOverlay()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
            <fa-icon icon="info"></fa-icon>
          </div>
          <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOverlayOpen" [cdkConnectedOverlayPanelClass]="sidenav.opened ? 'legend-overlay-container' : 'collapsed-legend-overlay-container'">
            <div class="overlay-side-nav-legend">
              <div class="side-legend-container">
                <div class="side-legend-title">Legend</div>
                <ng-container *ngFor="let category of (navService.landscapePageConfig.page == 2 ? legendConfigs[0].categories : legendConfigs[1].categories)">
                  <div [ngStyle]="{ 'background-color': navService.landscapePageConfig.useNewLayout ? category.bgColor1 : category.bgColor }" class="side-entity-legend">{{ category.name }}</div>
                </ng-container>
          
                <ng-container *ngIf="navService.landscapePageConfig.pageView !== 1 && (navService.landscapePageConfig.page == 2 || (navService.landscapePageConfig.page == 3 && navService.landscapePageConfig.useNewLayout))">
                  <ng-container *ngFor="let badge of (navService.landscapePageConfig.page == 2 ? legendConfigs[0].badges : legendConfigs[1].badges)">
                    <div class="side-legend-badge-desc">
                      <div [class]="badge.className" [ngStyle]="{ 'background-color': badge.bgColor }">
                        <fa-icon *ngIf="badge.icon" [icon]="badge.icon" [transform]="badge.transform"></fa-icon>
                        <ng-container *ngIf="!badge.icon">{{ badge.content }}</ng-container>
                      </div>{{ badge.name }}
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>
      <ng-template #sidebarLegendTemplate>
        <div *ngIf="sidenav.opened; else collapsedLegendTemplate" class="side-nav-legend">
          <div class="side-legend-container">
            <div class="side-legend-title">Legend</div>
            <ng-container *ngFor="let category of (navService.landscapePageConfig.page == 2 ? legendConfigs[0].categories : legendConfigs[1].categories)">
              <div [ngStyle]="{ 'background-color': navService.landscapePageConfig.useNewLayout ? category.bgColor1 : category.bgColor }" class="side-entity-legend" [matTooltip]="category.hasTooltip ? category.name : ''">{{ category.name }}</div>
            </ng-container>
      
            <ng-container *ngIf="navService.landscapePageConfig.pageView !== 1 && (navService.landscapePageConfig.page == 2 || (navService.landscapePageConfig.page == 3 && navService.landscapePageConfig.useNewLayout))">
              <ng-container *ngFor="let badge of (navService.landscapePageConfig.page == 2 ? legendConfigs[0].badges : legendConfigs[1].badges)">
                <div class="side-legend-badge-desc">
                  <div [class]="badge.className" [ngStyle]="{ 'background-color': badge.bgColor }">
                    <fa-icon *ngIf="badge.icon" [icon]="badge.icon" [transform]="badge.transform"></fa-icon>
                    <ng-container *ngIf="!badge.icon">{{ badge.content }}</ng-container>
                  </div>{{ badge.name }}
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
        <ng-template #collapsedLegendTemplate>
          <div class="side-nav-legend-collapsed">
            <div class="side-legend-container">
              <ng-container *ngFor="let category of (navService.landscapePageConfig.page == 2 ? legendConfigs[0].categories : legendConfigs[1].categories)">
                <div [ngStyle]="{ 'background-color': navService.landscapePageConfig.useNewLayout ? category.bgColor1 : category.bgColor }" class="side-entity-legend" [matTooltip]="category.name">{{ category.short }}</div>
              </ng-container>
        
              <ng-container *ngIf="navService.landscapePageConfig.pageView !== 1 && (navService.landscapePageConfig.page == 2 || (navService.landscapePageConfig.page == 3 && navService.landscapePageConfig.useNewLayout))">
                <ng-container *ngFor="let badge of (navService.landscapePageConfig.page == 2 ? legendConfigs[0].badges : legendConfigs[1].badges)">
                  <div class="side-legend-badge-desc">
                    <div [class]="badge.className" [ngStyle]="{ 'background-color': badge.bgColor }" [matTooltip]="badge.name">
                      <fa-icon *ngIf="badge.icon" [icon]="badge.icon" [transform]="badge.transform"></fa-icon>
                      <ng-container *ngIf="!badge.icon">{{ badge.content }}</ng-container>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-template>
      </ng-template>
    </ng-container>
  </mat-sidenav>

  <mat-sidenav-content style="overflow: hidden;">
    <div class="mainstage" [ngClass]="{ 'no-permission-container': !hasPermission }">
      <ng-container *ngIf="loadingMenu; else contentTemplate">
        <mat-spinner diameter=50 class="aip-topol-spinner"></mat-spinner>
      </ng-container>
      <ng-template #contentTemplate>
        <ng-container *ngIf="hasPermission; else noPermissionTemplate">
          <router-outlet></router-outlet>
        </ng-container>
        <ng-template #noPermissionTemplate>
          <div class="aip-theme-bg-alt no-permission-desc">
            <h1>403 Forbidden</h1>
            <div>Sorry, you are not authorized to access this page.</div>
          </div>
        </ng-template>
      </ng-template>
    </div>

  </mat-sidenav-content>
</mat-sidenav-container>
